import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { noop } from 'lodash';
import Modal from 'react-responsive-modal';

import 'react-select/dist/react-select.css';

class SelectInputAddNew extends React.PureComponent {
  static defaultProps = {
    value: '',
    placeholder: '',
    fieldSuffix: '',
    valid: true,
    options: [],
    clearable: false,
    onFormChange: noop,
    onModalClose: noop,
    formProps: {},
    addNewLabel: 'Add New',
  };

  constructor(props) {
    super(props);
    this.state = {
      formInput: {},
      showForm: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleAddNewClick = this.handleAddNewClick.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.generateAddNewOption = this.generateAddNewOption.bind(this);
    this.updateOptions = this.updateOptions.bind(this);
  }

  handleFormChange(formInput) {
    this.setState({ formInput });
    this.props.onFormChange(formInput);
  }

  async handleFormSubmit(formInput) {
    const {
      id, onChange, onBlur, onFormSubmit,
    } = this.props;
    // Let the onSubmit handler manipulate/derive a value from the form data.
    const submittedValue = await onFormSubmit(formInput);
    onChange(id, submittedValue);
    onBlur(id, submittedValue);
    this.handleModalClose();
  }

  handleAddNewClick() {
    this.setState({ showForm: true });
  }

  handleModalClose() {
    this.setState({ formInput: {}, showForm: false });
    this.props.onModalClose();
  }

  async handleChange(selectedOption) {
    if (!selectedOption) {
      return;
    }
    const { value } = selectedOption;
    if (value === 'addNewOption') {
      this.setState({ showForm: true });
    } else {
      const { id, onChange, onBlur } = this.props;
      await onChange(id, value);
      onBlur();
    }
  }

  generateAddNewOption() {
    return {
      value: 'addNewOption',
      label: (
        <button type="button" className="btn small" onClick={this.handleAddNewClick}>
          {this.props.addNewLabel}
        </button>
      ),
    };
  }

  updateOptions(options) {
    return options.concat([this.generateAddNewOption()]);
  }

  render() {
    const {
      id,
      value,
      placeholder,
      fieldSuffix,
      valid,
      options,
      clearable,
      formComponent,
      formProps,
    } = this.props;

    const validClass = valid ? '' : 'invalid';

    const Form = formComponent;
    const modal = this.state.showForm ? (
      <Modal
        open
        onClose={this.handleModalClose}
        classNames={{ overlay: 'loading-overlay', modal: 'modal-wrapper status' }}
        center
      >
        <Form
          onSubmit={this.handleFormSubmit}
          onChange={this.handleFormChange}
          formInput={this.state.formInput}
          {...formProps}
        />
      </Modal>
    ) : null;

    const noResults = (
      <div>
        <span>No Results</span>
        {this.generateAddNewOption().label}
      </div>
    );

    return (
      <div className="select-input add-new-option">
        {modal}
        <Select
          id={id}
          value={value}
          placeholder={placeholder}
          className={validClass}
          onChange={this.handleChange}
          options={this.updateOptions(options)}
          autoBlur
          clearable={clearable}
          noResultsText={noResults}
        />
        {fieldSuffix !== '' ? <span className="field-suffix">{fieldSuffix}</span> : null}
      </div>
    );
  }
}

SelectInputAddNew.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  fieldSuffix: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  valid: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]).isRequired,
    className: PropTypes.string,
  })),
  clearable: PropTypes.bool,
  formComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  onFormChange: PropTypes.func,
  onModalClose: PropTypes.func,
  formProps: PropTypes.shape({}),
  addNewLabel: PropTypes.string,
};

SelectInputAddNew.displayName = 'SelectInputAddNew';

export default SelectInputAddNew;



// WEBPACK FOOTER //
// ./src/components/formElements/SelectInputAddNew.js